<script context="module"></script>

<script>import { isEmptyElement } from "./dynamic-renderer.helpers";
import { setAttrs } from "../../blocks/helpers";
export let TagName;
export let attributes;
export let actionAttributes;
</script>

{#if !isEmptyElement(TagName)}
  {#if typeof TagName === "string"}
    <svelte:element
      this={TagName}
      {...attributes}
      use:setAttrs={actionAttributes}><slot /></svelte:element
    >
  {:else}
    <svelte:component this={TagName} {...attributes} {...actionAttributes}
      ><slot /></svelte:component
    >
  {/if}
{:else}
  <svelte:element
    this={TagName}
    {...attributes}
    use:setAttrs={actionAttributes}
  />
{/if}